import base58 from '../utils/base58';
import cryptoUtils from '../utils/utils';

/**
 * Validator for Ergo addresses.
 * https://github.com/fleet-sdk/fleet/blob/master/packages/core/src/models/utils.ts#L10
 */
export default {
    isValidAddress(address, currency, networkType) {
        try {
            const decoded = base58.decode(address);
            if (!(decoded[0] === 1 && address.length === 51)) {
                return false;
            }

            const computedChecksum = cryptoUtils.blake2b256(cryptoUtils.toHex(decoded.slice(0, -4)));
            const checksum = cryptoUtils.toHex(decoded.slice(-4));
    
            return computedChecksum.slice(0, 8) === checksum;
        }  catch (e) {
            return false;
        }
    },
};
